import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  client: "",
  objectIdentifier: "",
  objectName: "",
  dcKWh: "",
  firstFreeMinutes: "",
  startingFee: "",
  dcMinute: "",
  acMinute: "",
  monthlyFee: "",
  acKWh: "",
};
// const initialState = { value: 0 };

const registrationCodeSlice = createSlice({
  name: "registrationCode",
  initialState,
  reducers: {
    setRegistrationCode: (state, { payload }) => {
      const { client, objectIdentifier, objectName, imageUrl } =
        payload["data"];

      state.client = client;
      state.objectIdentifier = objectIdentifier;
      state.objectName = objectName;
      state.imageUrl = imageUrl;
    },
    setTarif: (state, { payload }) => {
      console.log(payload.data.Tarif);
      const {
        dcKWh,
        firstFreeMinutes,
        startingFee,
        dcMinute,
        acMinute,
        monthlyFee,
        acKWh,
      } = payload.data.Tarif;
      state.dcKWh = dcKWh;
      state.firstFreeMinutes = firstFreeMinutes;
      state.startingFee = startingFee;
      state.dcMinute = dcMinute;
      state.acMinute = acMinute;
      state.monthlyFee = monthlyFee;
      state.acKWh = acKWh;
    },
  },
});
export const getRegistrationCode = (state) => state;
export const { setRegistrationCode, setTarif } = registrationCodeSlice.actions;

export default registrationCodeSlice.reducer;
